// actions.js
import { GET_ALL_CATEGORY, GET_ALL_CATEGORY_ERROR, GET_ALL_CATEGORY_SUCCESS,GET_ALL_SERVICES,GET_ALL_SERVICES_SUCCESS,GET_ALL_SERVICES_ERROR, GET_ALL_COUNTRIES, GET_ALL_COUNTRIES_SUCCESS, GET_ALL_COUNTRIES_ERROR, GET_POLICIES, GET_POLICIES_SUCCESS, GET_POLICIES_ERROR, GET_ALL_PRODUCTS, CREATE_SERVICES,CREATE_HELPDESK, CREATE_SERVICES_SUCCCESS, CREATE_SERVICES_ERROR, UPDATE_SERVICES, UPDATE_SERVICES_SUCCCESS, UPDATE_SERVICES_ERROR, CHANGE_STATUS_SERVICES, CHANGE_STATUS_SERVICES_SUCCCESS, CHANGE_STATUS_SERVICES_ERROR, CHANGE_STATUS_SERVICES_TO_ACTIVE, CHANGE_STATUS_SERVICES_TO_ACTIVE_SUCCESS, CHANGE_STATUS_SERVICES_TO_ACTIVE_ERROR, UPDATE_SERVICES_STATUS, UPDATE_SERVICES_STATUS_SUCCCESS, UPDATE_SERVICES_STATUS_ERROR, DELETE_SERVICES, DELETE_SERVICES_SUCCESS, DELETE_SERVICES_ERROR, GET_ALL_COUPONS, GET_ALL_COUPONS_SUCCESS, GET_ALL_COUPONS_ERROR, CREATE_COUPONS_ERROR, CREATE_COUPONS, UPDATE_COUPONS_STATUS_SUCCESS, UPDATE_COUPONS_STATUS, UPDATE_COUPONS_STATUS_ERROR, CREATE_COUPONS_SUCCESS, UPDATE_COUPONS, UPDATE_COUPONS_SUCCESS, UPDATE_COUPONS_ERROR, CHANGE_STATUS_COUPONS, CHANGE_STATUS_COUPONS_SUCCESS, CHANGE_STATUS_COUPONS_ERROR, CHANGE_STATUS_COUPONS_TO_ACTIVE, CHANGE_STATUS_COUPONS_TO_ACTIVE_SUCCESS, CHANGE_STATUS_COUPONS_TO_ACTIVE_ERROR,GET_ALL_PRODUCTS_SUCCESS, GET_ALL_PRODUCTS_ERROR, 
  GET_CATEGORY_FOR_ALL, GET_CATEGORY_FOR_ALL_SUCCESS, GET_CATEGORY_FOR_ALL_ERROR } from '../actionTypes'

export const getAllCategoryRedux = (setTotalData,setDataHolder,settotalPage,getCount) => ({
  type: GET_ALL_CATEGORY,
  payload: { setTotalData, setDataHolder,settotalPage,getCount } 
});

export const getAllCategoryReduxSuccess = (data) => ({
  type: GET_ALL_CATEGORY_SUCCESS,
  payload: data,
});

export const getAllCategoryReduxError = (error) => ({
  type: GET_ALL_CATEGORY_ERROR,
  payload: error,
});

export const getServices = (page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading) => ({
  type: GET_ALL_SERVICES,
  payload: { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } 
});

export const getServicesSuccess = (data) => ({
  type: GET_ALL_SERVICES_SUCCESS,
  payload: data,
});

export const getServicesError = (error) => ({
  type: GET_ALL_SERVICES_ERROR,
  payload: error,
});

export const createServices = (formData, toggleModal, refresh, setIsSubmitting) => ({
  type: CREATE_SERVICES,
  payload: { formData, toggleModal, refresh, setIsSubmitting },
});

// 08.08.2023
export const createHelpDesk = (formData, toggleModal, refresh, setIsSubmitting) => ({
  type: CREATE_HELPDESK,
  payload: { formData, toggleModal, refresh, setIsSubmitting },
});

export const createServicesSuccess = (data) => ({
  type: CREATE_SERVICES_SUCCCESS,
  payload: data,
});

export const createServicesError = (error) => ({
  type: CREATE_SERVICES_ERROR,
  payload: error,
});

// Update Services Status
export const updateServicesStatus = (sales_service_id) => ({
  type: UPDATE_SERVICES_STATUS,
  payload: { sales_service_id },
});

export const updateServicesStatusSuccess = (data) => ({
  type: UPDATE_SERVICES_STATUS_SUCCCESS,
  payload: data,
});

export const updateServicesStatusError = (error) => ({
  type: UPDATE_SERVICES_STATUS_ERROR,
  payload: error,
});

// Update Services
export const updateServices = (sales_service_id, ServiceData, toggleModal, refresh, setIsSubmitting) => ({
  type: UPDATE_SERVICES,
  payload: { sales_service_id, ServiceData, toggleModal, refresh, setIsSubmitting },
});

export const updateServicesSuccess = (data) => ({
  type: UPDATE_SERVICES_SUCCCESS,
  payload: data,
});

export const updateServicesError = (error) => ({
  type: UPDATE_SERVICES_ERROR,
  payload: error,
});

// Delete Service
export const deleteServices = (sales_service_id, statusData, refresh) => ({
  type: DELETE_SERVICES,
  payload: { sales_service_id, statusData, refresh },
});

export const deleteServicesSuccess = (data) => ({
  type: DELETE_SERVICES_SUCCESS,
  payload: data,
});

export const deleteServicesError = (error) => ({
  type: DELETE_SERVICES_ERROR,
  payload: error,
});

// Change Service Status
export const changeStatusServices = (sales_service_id, payload_param, refresh) => ({
  type: CHANGE_STATUS_SERVICES,
  payload: { sales_service_id, payload_param, refresh },
});

export const changeStatusServicesSuccess = (data) => ({
  type: CHANGE_STATUS_SERVICES_SUCCCESS,
  payload: data,
});

export const changeStatusServicesError = (error) => ({
  type: CHANGE_STATUS_SERVICES_ERROR,
  payload: error,
});

export const changeStatusServicestoActive = (sales_service_id, refresh) => ({
  type: CHANGE_STATUS_SERVICES_TO_ACTIVE,
  payload: { sales_service_id, refresh },
});

export const changeStatusServicesSuccesstoActive = (data) => ({
  type: CHANGE_STATUS_SERVICES_TO_ACTIVE_SUCCESS,
  payload: data,
});

export const changeStatusServicesErrortoActive = (error) => ({
  type: CHANGE_STATUS_SERVICES_TO_ACTIVE_ERROR,
  payload: error,
});

export const getCountries = () => ({
  type: GET_ALL_COUNTRIES,
});

export const getCountriesSuccess = (data) => ({
  type: GET_ALL_COUNTRIES_SUCCESS,
  payload: data,
});

export const getCountriessError = (error) => ({
  type: GET_ALL_COUNTRIES_ERROR,
  payload: error,
});


export const getAllProducts = (page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading) => ({
  type: GET_ALL_PRODUCTS,
  payload: { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } 
});

export const getCoupons = (page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading) => ({
  type: GET_ALL_COUPONS,
  payload: { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } 
});

export const getCouponsSuccess = (data) => ({
  type: GET_ALL_COUPONS_SUCCESS,
  payload: data,
});

export const getCouponsError = (error) => ({
  type: GET_ALL_COUPONS_ERROR,
  payload: error,
});

export const createCoupons = (formData, toggleModal, refresh, setIsSubmitting) => ({
  type: CREATE_COUPONS,
  payload: { formData, toggleModal, refresh, setIsSubmitting },
});

export const createCouponsSuccess = (data) => ({
  type: CREATE_COUPONS_SUCCESS,
  payload: data,
});

export const createCouponsError = (error) => ({
  type: CREATE_COUPONS_ERROR,
  payload: error,
});

export const updateCouponsStatus = (sales_coupon_id) => ({
  type: UPDATE_COUPONS_STATUS,
  payload: { sales_coupon_id },
});

export const updateCouponsStatusSuccess = (data) => ({
  type: UPDATE_COUPONS_STATUS_SUCCESS,
  payload: data,
});

export const updateCouponsStatusError = (error) => ({
  type: UPDATE_COUPONS_STATUS_ERROR,
  payload: error,
});

export const updateCoupons = (sales_coupon_id, CouponData, toggleModal, refresh, setIsSubmitting) => ({
  type: UPDATE_COUPONS,
  payload: { sales_coupon_id, CouponData, toggleModal, refresh, setIsSubmitting },
});

export const updateCouponsSuccess = (data) => ({
  type: UPDATE_COUPONS_SUCCESS,
  payload: data,
});

export const updateCouponsError = (error) => ({
  type: UPDATE_COUPONS_ERROR,
  payload: error,
});

export const getAllProductsRedux = (setTotalData,setDataHolder,settotalPage,getCount) => ({
  type: GET_ALL_PRODUCTS,
  payload: { setTotalData, setDataHolder,settotalPage,getCount } 
});

export const getAllProductsReduxSuccess = (data) => ({
  type: GET_ALL_PRODUCTS_SUCCESS,
  payload: data,
});

export const getAllProductsSuccess = (data) => ({
  type: GET_ALL_PRODUCTS_SUCCESS,
  payload: data,
});

export const getAllProductsError = (error) => ({
  type: GET_ALL_PRODUCTS_ERROR,
  payload: error,
});

export const getAllProductsReduxError = (error) => ({
  type: GET_ALL_PRODUCTS_ERROR,
  payload: error,
});

export const getPoliciesData = () => ({
  type: GET_POLICIES,
});

export const getPoliciesDataSuccess = (data) => ({
  type: GET_POLICIES_SUCCESS,
  payload: data,
});

export const getPoliciesDataError = (error) => ({
  type: GET_POLICIES_ERROR,
  payload: error,
});

export const changeStatusCoupons = (sales_coupon_id, payload_param, refresh) => ({
  type: CHANGE_STATUS_COUPONS,
  payload: { sales_coupon_id, payload_param, refresh },
});

export const changeStatusCouponsSuccess = (data) => ({
  type: CHANGE_STATUS_COUPONS_SUCCESS,
  payload: data,
});

export const changeStatusCouponsError = (error) => ({
  type: CHANGE_STATUS_COUPONS_ERROR,
  payload: error,
});

export const changeStatusCouponstoActive = (sales_coupon_id, refresh) => ({
  type: CHANGE_STATUS_COUPONS_TO_ACTIVE,
  payload: { sales_coupon_id, refresh },
});

export const changeStatusCouponsSuccesstoActive = (data) => ({
  type: CHANGE_STATUS_COUPONS_TO_ACTIVE_SUCCESS,
  payload: data,
});

export const changeStatusCouponsErrortoActive = (error) => ({
  type: CHANGE_STATUS_COUPONS_TO_ACTIVE_ERROR,
  payload: error,
});


export const getCategoryForAll = () => ({
  type: GET_CATEGORY_FOR_ALL,
  payload: { } 
});

export const getCategoryForAllSuccess = (data) => ({
  type: GET_CATEGORY_FOR_ALL_SUCCESS,
  payload: data,
});

export const getCategoryForAllError = (error) => ({
  type: GET_CATEGORY_FOR_ALL_ERROR,
  payload: error,
});
